<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import InputText from 'primevue/inputtext';
import Card from 'primevue/card';
import texts from '../encrypted_texts.json'
import AES from 'crypto-js/aes'
import Utf8 from 'crypto-js/enc-utf8'
import { ref, computed, watch } from 'vue';

const props = defineProps({
  modelValue: String,
});

const emit = defineEmits(['update:modelValue']);

// Read URL parameter 'passcode' if it exists
const urlParams = new URLSearchParams(window.location.search);
const value = ref<string>(urlParams.get('passcode') || props.modelValue || '');

const valueCleaned = computed(() => {
  // Remove all non-digit characters
  return value.value.replace(/\./g, '');
});

const passCodeCorrect = computed(() => {
  if (!value.value) return false;
  try {
    const test = AES.decrypt(texts.greeting, valueCleaned.value).toString(Utf8);
    return test !== "";
  } catch {
    return false;
  }

})

watch(valueCleaned, (newValue) => {
  // Try to decrypt texts_encrypted.json
  try {
    const test = AES.decrypt(texts.greeting, newValue).toString(Utf8);
    if (test !== "") {
      emit('update:modelValue', newValue);
    }
    else {
      emit('update:modelValue', "");
    }
  }
  catch {
    emit('update:modelValue', "");
    return;
  }

}, { immediate: true });
</script>

<template>

  <div id="otp-container" v-if="!passCodeCorrect">
    <Card class="responsive-card">
      <template #content>
        <div id="otp-content">
          <div class="text otp-label">Bitte gib unser Hochzeitsdatum ein:</div>
          <InputText v-model="value" size="small" :length="8" :invalid="value.length === 8 && !passCodeCorrect"
            placeholder="dd.mm.yyyy" />
          <!-- <div class="otp-wrapper">
            <InputOtp v-model="value" integerOnly size="small" :length="8"
              :invalid="value.length === 8 && !passCodeCorrect" />
        </div> -->
        </div>
      </template>
    </Card>
  </div>
</template>

<style scoped lang="scss">
#otp-container {
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  position: fixed;
  top: 0;
  left: 0;
  background-color: $color-background;
  opacity: 0.95;
  backdrop-filter: blur(50px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.responsive-card {
  width: 90vw !important;
  max-width: 600px;
}

.otp-wrapper {
  width: 100%;
  overflow-x: hidden;

  :deep(.p-inputotp) {
    justify-content: center;
    transform-origin: center;
    width: 100%;
    gap: 4px;
  }

  :deep(.p-inputtext) {
    width: min(40px, 10vw);
    height: min(40px, 10vw);
    font-size: min(24px, 6vw);
  }
}

#otp-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.otp-label {
  margin-bottom: $default-space;
}
</style>
